/*
 * @Author: LQ
 * @Date: 2022-06-09 10:29:57
 * @LastEditors: HRD
 * @LastEditTime: 2022-08-09 14:29:07
 * @FilePath: \scm-pc\src\official\config\cache.js
 * @Description:
 *
 * Copyright (c) 2022 by LQ/量迅, All Rights Reserved.
 */

export const OFFICIAL_INIT_DATA_KEY = 'OFFICIAL_INIT_DATA_KEY__';
export const OFFICIAL_PAGE_TYPE_KEY = 'OFFICIAL_PAGE_TYPE_KEY';
